export default function NoSmoking() {
  return (
    <div
      className="ion-icon-no-smoking"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
<![CDATA[
	.st0{fill:#010101;}
]]>
</style>
<g>
	<rect x="360" y="256" class="st0" width="16" height="48"/>
	<polygon class="st0" points="112,304 249.6,304 201.6,256 112,256 	"/>
	<path class="st0" d="M364.5,60.1c-0.4-0.2-0.7-0.4-1-0.6c-10.9-6-22.5-10.7-34.4-14.8c-1.8-0.6-3.6-1.2-5.4-1.8
		C302.3,36.1,279.6,32,256,32C132.3,32,32,132.3,32,256c0,84.3,46.6,157.6,115.4,195.8c0.4,0.2,0.7,0.5,1.1,0.7
		c10.9,6,22.5,10.7,34.4,14.8c1.8,0.6,3.6,1.2,5.4,1.8c21.4,6.8,44,10.9,67.7,10.9c123.7,0,224-100.3,224-224
		C480,171.7,433.4,98.3,364.5,60.1z M256,426.4c-9.3,0-18.4-0.9-27.2-2.4c-9.8-1.6-19.3-4.1-28.5-7.3c-1.9-0.6-3.8-1.2-5.6-1.9
		c-6.5-2.5-12.9-5.3-19-8.6c-53.6-28.7-90.1-85.2-90.1-150.3c0-37.2,12.4-71.4,32.7-99.4l237.2,237.2
		C327.4,414,293.2,426.4,256,426.4z M393.8,355.4L156.6,118.2c28-20.2,62.1-32.6,99.4-32.6c9.3,0,18.3,0.9,27.2,2.4
		c9.8,1.6,19.3,4.1,28.5,7.3c1.8,0.6,3.7,1.2,5.6,1.9c6.2,2.4,12.2,5,18,8.1c54.2,28.5,91.2,85.3,91.2,150.8
		C426.4,293.3,414,327.4,393.8,355.4z"/>
	<polygon class="st0" points="352,298 352,256 310,256 	"/>
	<rect x="384" y="256" class="st0" width="16" height="48"/>
	<path class="st0" d="M360.1,212.7c-8.8-4.1-22-5.7-45.6-5.7c-1.2,0-2.4,0-3.6,0c-12.7,0.1-15.9-0.1-20-6.1
		c-2.8-4.2-1-14.8,3.7-21.9c1.6-2.4,1.8-5.6,0.4-8.2c-1.4-2.6-4.1-4.2-7-4.3c-0.1,0-9.4-0.1-18.3-3.9c-10.6-4.5-15.6-12.1-15.6-23.1
		c0-25.8,21.8-27.7,22.8-27.7v-16c-12,0-38.8,11-38.8,43.7c0,17.5,9,31,25.7,38c4.2,1.7,8.4,2.9,12,3.6c-3.3,9.8-3.6,20.9,1.7,28.7
		c9,13.3,20.3,13.2,33.3,13.1c1.1,0,2.3,0,3.5,0c26.3,0,34.6,2.3,38.9,4.3c5.7,2.6,6.8,11.5,6.6,19.7c0,0.7,0,0.4,0,1h16
		c0-0.4,0-0.4,0-1C375.8,239.8,376.1,220.1,360.1,212.7z"/>
	<path class="st0" d="M400,248c0-25.7-3-43.2-9.1-53.6C382.3,180,368.5,172,352,172h-17.4c2.9-8.3,5.4-19.8,3.5-30.9
		c-3.2-18.8-19.1-30-43.1-30v16c21,0,26.1,9.1,27.4,16.7c2.5,14.5-6.8,32.1-6.9,32.3c-1.4,2.5-1.3,5.5,0.1,7.9
		c1.4,2.4,4.1,3.9,6.9,3.9H352c10.9,0,19.4,4.9,25.1,14.6c3.1,5.3,6.9,17.5,6.9,45.4H400z"/>
</g>
</svg>
`,
      }}
    />
  )
}
